import React, { ReactNode, useEffect, useRef } from 'react';
import styled from 'styled-components';

import DNSlideTabItem from '@/designComponents/organisms/DNSlideTab/DNSlideTabItem';

interface DNSlideTabProps<T> {
  value: T;
  group?: boolean;
  children: ReactNode;
}
const DNSlideTab = <T,>({
  value,
  group = false,
  children,
}: DNSlideTabProps<T>) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!value) return;
    if (!scrollRef.current) return;

    const children = Array.from(scrollRef.current.children);
    children.forEach((child) => {
      if (child.classList.contains('DNSlideTabItem_selected')) {
        const { left, width } = child.getBoundingClientRect();
        const innerWidth = window.innerWidth;
        if (left + width / 2 !== innerWidth / 2) {
          scrollRef.current?.scrollTo({
            top: 0,
            left:
              scrollRef.current?.scrollLeft +
              (left - innerWidth / 2 + width / 2),
            behavior: 'smooth',
          });
        }
      }
    });
  }, [value]);

  return (
    <Container>
      <Wrapper ref={scrollRef} group={group}>
        {children}
      </Wrapper>
      <BorderBottom />
    </Container>
  );
};

DNSlideTab.Item = DNSlideTabItem;

export default DNSlideTab;

const Container = styled.div`
  position: relative;
`;

const Wrapper = styled.div<{ group: boolean }>`
  display: flex;
  overflow-x: auto;
  padding: 0 24px;
  gap: 12px;

  ${({ group }) => `
    ${
      group
        ? `
          button {
            flex: 1;
            span {
              width: 100%;
            }
          }`
        : ''
    };
  `};
`;

const BorderBottom = styled.div`
  height: 1px;
  width: 100%;
  position: absolute;
  bottom: 0;
  ${({ theme }) => `
    border-bottom: 1px solid ${theme.color.gray100};
  `};
`;
